"use strict"

import React, { useState } from "react"
import { Button } from "react-bootstrap"

import { PageTitle } from "../../config/AppSettingsConfigProvider"
import { withFermManagementConfig } from "../../config/FermManagementConfigProvider"
import { getFormattedMessage } from "../shared_components_registration"
import ProjectHierarchyModal from "./modals/ProjectHierarchyModal"
import RunMetadataFieldsModal from "./modals/RunMetadataFieldsModal"
import RunManagement from "./RunManagement"

function FermManagement({ IS_PROJECT_EXPERIMENT_SITE = false, permissions, intl }) {
  const [showMetadataModal, setShowMetadataModal] = useState(false)
  const [showProjectHierarchyModal, setShowProjectHierarchyModal] = useState(false)
  const canEditRunMetadataFields = permissions.includes("can_edit_run_metadata_fields")
  const canManageProjectHierarchy =
    permissions.includes("edit_project") ||
    permissions.includes("edit_project_task") ||
    permissions.includes("edit_experiment")
  const manageMetaTitle = intl.formatMessage({
    id: "fermmanagement.run.metadata",
    defaultMessage: "Run Metadata Fields",
  })
  const manageProjectHierarchyTitle = `${getFormattedMessage("general.projects", "Projects", true)} / ${getFormattedMessage("general.project.tasks", "Tasks", true)} / ${getFormattedMessage("general.project.experiments", "Experiments", true)}`

  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle
          glyph={"play"}
          id={"navigation.fermManagementOption"}
          description={"Fermentation Management"}
          ExtraElement={() => (
            <div style={{ display: "grid", float: "right" }}>
              <Button
                variant={"outline-primary"}
                onClick={(e) => {
                  e.preventDefault()
                  setShowMetadataModal(true)
                }}
                disabled={!canEditRunMetadataFields}
              >
                <span className={"fa fa-pencil-square-o"} />
                &nbsp;
                {manageMetaTitle}
              </Button>
              {IS_PROJECT_EXPERIMENT_SITE && (
                <Button
                  variant={"outline-primary"}
                  onClick={(e) => {
                    e.preventDefault()
                    setShowProjectHierarchyModal(true)
                  }}
                  disabled={!canManageProjectHierarchy}
                >
                  <span className={"fa fa-sitemap"} />
                  &nbsp;
                  {manageProjectHierarchyTitle}
                </Button>
              )}
            </div>
          )}
        />
        {showMetadataModal && (
          <RunMetadataFieldsModal
            show={showMetadataModal}
            onHide={() => setShowMetadataModal(false)}
            title={manageMetaTitle}
            intl={intl}
          />
        )}
        {showProjectHierarchyModal && (
          <ProjectHierarchyModal
            show={showProjectHierarchyModal}
            onHide={() => setShowProjectHierarchyModal(false)}
            title={manageProjectHierarchyTitle}
            intl={intl}
          />
        )}
        <RunManagement intl={intl} />
      </div>
    </div>
  )
}

export default withFermManagementConfig(FermManagement)
